// extracted by mini-css-extract-plugin
module.exports = {"TableFooter":"DealTable_TableFooter__lo9BX","PaginationContainer":"DealTable_PaginationContainer__nK789"};